// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { setUser } from "../redux/slices/userSlice";

// const useAuth = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [user, setUUser] = useState(null);
//   const [token, setToken] = useState(null);

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const userData = params.get("user");
//     const userToken = params.get("token");

//     if (userData && userToken) {
//       try {
//         const userObject = JSON.parse(decodeURIComponent(userData));
//         setUUser(userObject);
//         setToken(userToken);

//         // Save to session storage
//         sessionStorage.setItem("user", JSON.stringify(userObject));
//         sessionStorage.setItem("token", userToken);
//         dispatch(
//           setUser({ user: JSON.stringify(userObject), token: userToken })
//         );
//       } catch (error) {
//         console.error("Error parsing user data from URL:", error);
//         navigate("/login");
//       }
//     } else {
//       const storedUser = sessionStorage.getItem("user");
//       const storedToken = sessionStorage.getItem("token");

//       if (storedUser && storedToken) {
//         const parsedUser = JSON.parse(storedUser);
//         setUUser(parsedUser);
//         setToken(storedToken);
//         dispatch(setUser({ user: parsedUser, token: storedToken }));
//       } else {
//         console.error("No user data found in URL or session storage.");
//         navigate("/login");
//       }
//     }
//   }, [navigate]);

//   useEffect(() => {
//     if (user && token) {
//       const redirectPath = sessionStorage.getItem("redirectPath");
//       if (redirectPath) {
//         navigate(redirectPath, { replace: true });
//         sessionStorage.removeItem("redirectPath");
//         return;
//       }

//       if (user.role === "teacher") {
//         navigate("/dashboard");
//       } else if (user.role === "student") {
//         navigate("/");
//       } else if (user.role === "admin") {
//         navigate("/admin-dashboard");
//       }
//     }
//   }, [user, token, navigate]);

//   return { user, token };
// };

// export default useAuth;

// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { setUser } from "../redux/slices/userSlice";

// const useAuth = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [user, setUUser] = useState(null);
//   const [token, setToken] = useState(null);

//   useEffect(() => {
//     // ✅ Remove early return for "/"
//     const params = new URLSearchParams(window.location.search);
//     const userData = params.get("user");
//     const userToken = params.get("token");

//     if (userData && userToken) {
//       try {
//         const userObject = JSON.parse(decodeURIComponent(userData));
//         setUUser(userObject);
//         setToken(userToken);

//         // ✅ Save to session storage
//         sessionStorage.setItem("user", JSON.stringify(userObject));
//         sessionStorage.setItem("token", userToken);
//         dispatch(setUser({ user: userObject, token: userToken }));

//         // ✅ Remove query params from URL
//         navigate("/", { replace: true });
//       } catch (error) {
//         console.error("Error parsing user data from URL:", error);
//         navigate("/login");
//       }
//     } else {
//       // ✅ Retrieve from sessionStorage
//       const storedUser = sessionStorage.getItem("user");
//       const storedToken = sessionStorage.getItem("token");

//       if (storedUser && storedToken) {
//         const parsedUser = JSON.parse(storedUser);
//         setUUser(parsedUser);
//         setToken(storedToken);
//         dispatch(setUser({ user: parsedUser, token: storedToken }));
//       } else {
//         console.error("No user data found.");
//         if (window.location.pathname !== "/") {
//           navigate("/login"); // Redirect only if the user is NOT on "/"
//         }
//       }
//     }
//   }, [dispatch, navigate]);

//   useEffect(() => {
//     if (!user || !token) return;

//     const redirectPath = sessionStorage.getItem("redirectPath");
//     if (redirectPath) {
//       navigate(redirectPath, { replace: true });
//       sessionStorage.removeItem("redirectPath");
//       return;
//     }

//     // ✅ Correct redirection
//     if (user.role === "teacher") {
//       navigate("/dashboard", { replace: true });
//     } else if (user.role === "student" && window.location.pathname !== "/") {
//       navigate("/", { replace: true });
//     } else if (user.role === "admin") {
//       navigate("/admin-dashboard", { replace: true });
//     }
//   }, [user, token, navigate]);

//   return { user, token };
// };

// export default useAuth;

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { setUser } from "../redux/slices/userSlice";

// const useAuth = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [user, setUUser] = useState(null);
//   const [token, setToken] = useState(null);

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const userData = params.get("user");
//     const userToken = params.get("token");

//     if (userData && userToken) {
//       try {
//         const userObject = JSON.parse(decodeURIComponent(userData));
//         setUUser(userObject);
//         setToken(userToken);

//         sessionStorage.setItem("user", JSON.stringify(userObject));
//         sessionStorage.setItem("token", userToken);
//         dispatch(setUser({ user: userObject, token: userToken }));

//         // ✅ Redirect based on role
//         if (userObject.role === "teacher") {
//           navigate("/dashboard", { replace: true });
//         } else if (userObject.role === "admin") {
//           navigate("/admin-dashboard", { replace: true });
//         } else {
//           // Students go back to the page they wanted
//           const redirectPath = sessionStorage.getItem("redirectPath") || "/";
//           sessionStorage.removeItem("redirectPath");
//           navigate(redirectPath, { replace: true });
//         }
//       } catch (error) {
//         console.error("Error parsing user data from URL:", error);
//         navigate("/login");
//       }
//     } else {
//       const storedUser = sessionStorage.getItem("user");
//       const storedToken = sessionStorage.getItem("token");

//       if (storedUser && storedToken) {
//         setUUser(JSON.parse(storedUser));
//         setToken(storedToken);
//         dispatch(setUser({ user: JSON.parse(storedUser), token: storedToken }));
//       }
//     }
//   }, [dispatch, navigate]);

//   return { user, token };
// };

// export default useAuth;

import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/slices/userSlice";

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // ✅ Get current path
  const [user, setUUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userData = params.get("user");
    const userToken = params.get("token");

    if (userData && userToken) {
      try {
        const userObject = JSON.parse(decodeURIComponent(userData));
        setUUser(userObject);
        setToken(userToken);

        sessionStorage.setItem("user", JSON.stringify(userObject));
        sessionStorage.setItem("token", userToken);
        dispatch(setUser({ user: userObject, token: userToken }));

        // ✅ Restore last visited page if available
        const redirectPath = sessionStorage.getItem("redirectPath") || "/";
        sessionStorage.removeItem("redirectPath");

        if (redirectPath === "/" || redirectPath === "/login") {
          if (userObject.role === "teacher")
            navigate("/dashboard", { replace: true });
          else if (userObject.role === "admin")
            navigate("/admin-dashboard", { replace: true });
          else if (userObject.role === "caller")
            navigate("/caller-dashboard", { replace: true });
          else navigate("/", { replace: true });
        } else {
          navigate(redirectPath, { replace: true });
        }
      } catch (error) {
        console.error("Error parsing user data from URL:", error);
        navigate("/login");
      }
    } else {
      // ✅ Handle existing session users
      const storedUser = sessionStorage.getItem("user");
      const storedToken = sessionStorage.getItem("token");

      if (storedUser && storedToken) {
        const parsedUser = JSON.parse(storedUser);
        setUUser(parsedUser);
        setToken(storedToken);
        dispatch(setUser({ user: parsedUser, token: storedToken }));

        if (location.pathname === "/" || location.pathname === "/login") {
          if (parsedUser.role === "teacher")
            navigate("/dashboard", { replace: true });
          else if (parsedUser.role === "admin")
            navigate("/admin-dashboard", { replace: true });
        }
      }
    }
  }, [dispatch, navigate, location.pathname]);

  return { user, token };
};

export default useAuth;
